import { PostHog } from "posthog-js";
import { useEffect, useRef } from "react";

const MININUM_TIME_MS = 1_000;

export function usePageTimeTracking(
  pageName: string,
  posthog?: PostHog,
) {
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!posthog?.capture) return;

    // Start timer when posthog is ready
    startTimeRef.current = Date.now();

    return () => {
      const durationMs = Date.now() - startTimeRef.current;

      if (durationMs < MININUM_TIME_MS) return;

      posthog.capture("time_spent_on_page", {
        pageName,
        duration_ms: durationMs,
      });
    };
  }, [posthog, pageName]);
}
